module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Weight2-cabd19c5b91b2ecdf152e4af47874c99.svg";